document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.logo-slider').forEach(function(slider) {
    new Splide(slider, {
      type: 'loop',
      perPage: 5,
      perMove: 1,
      // direction: 'rtl',
      direction: 'ltr',
      gap: '30px',
      arrows: false,
      pagination: false,

      autoplay: true,
      interval: 3000,
      speed: 6000,
      easing: 'linear',
      drag: true,
      pauseOnHover: true,
      pauseOnFocus: false,
      breakpoints: {
        990: {
          perPage: 4
        },
        749: {
          perPage: 3
        },
        480: {
          perPage: 2
        }
      }
    }).mount();
  });
});

// treatment_menu

  // document.addEventListener('DOMContentLoaded', function () {
  //   const accordions = document.querySelectorAll('.Collapsible_content details');
    
  //   accordions.forEach((accordion) => {
  //     accordion.addEventListener('click', function (e) {
  //       accordions.forEach((item) => {
  //         if (item !== accordion && item.hasAttribute('open')) {
  //           item.removeAttribute('open');
  //         }
  //       });
  //     });
  //   });
  // });


  document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.Collapsible_content details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('click', function () {
      const container = accordion.closest('.Collapsible_content');

      if (!container) return;

      const containerAccordions = container.querySelectorAll('details');

      containerAccordions.forEach((item) => {
        if (item !== accordion && item.hasAttribute('open')) {
          item.removeAttribute('open');
        }
      });
    });
  });
});

// our_philosopy
  
  document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.custom_collapsible_content details');
    
    accordions.forEach((accordion) => {
      accordion.addEventListener('click', function (e) {
        accordions.forEach((item) => {
          if (item !== accordion && item.hasAttribute('open')) {
            item.removeAttribute('open');
          }
        });
      });
    });
  });
